export default __webpack_public_path__ + "static/media/מועמדים-פוטושופ---סופי_0000s_0000_Black-&-White-42.3687287a.png";